<template>
  <div class="progress-steps-item">
    <img
      v-if="state === 'todo'"
      class="progress"
      alt="progress item todo"
      src="@shared/assets/img/progress_incomplete.svg"
    />
    <KDSSpinner
      v-else-if="state === 'in_progress'"
      class="progress"
    />
    <img
      v-else
      class="progress"
      alt="progress item complete"
      src="@shared/assets/img/progress_complete.svg"
    />
    <div :class="{ content: true, muted }">
      <slot />
    </div>
  </div>
</template>
<script setup>
import KDSSpinner from '@shared/components/KDSSpinner.vue'

defineProps({
  state: {
    type: String,
    default: 'complete',
    validator: (val) => ['todo', 'in_progress', 'done'].includes(val),
  },
  muted: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
.progress-steps-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: $kds-space-2x;
  position: relative;

  .progress {
    width: $kds-space-2x;
    height: $kds-space-2x;
    background-color: $kds-color-background-base;
    z-index: 2;
  }

  .content {
    flex-grow: 1;

    &.muted {
      opacity: 0.5;
    }
  }
}
</style>
